<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <div class="container">
            <h1>ニュース配信確認</h1>
            <h3 v-show="err_catch" class="err_msg">エラー</h3>
            <h3 v-show="err_mail_catch" class="err_msg">メール送信エラー</h3>
            <p class="pc_bolder">PC表示イメージ</p>
            <div class="admin_news_confirm_wrap">
                <table>
                    <tr>
                        <th>配信予約日時</th>
                        <td>{{ news.post_date | moment("YYYY/MM/DD HH:mm:ss") }}</td>
                    </tr>
                    <tr>
                        <th>タイトル</th>
                        <td>{{ news.notice_title }}</td>
                    </tr>
                    <tr>
                        <th>本文</th>
                        <td>{{ news.notice_text }}</td>
                    </tr>
                    <tr>
                        <th>ファイル</th>
                        <td>{{ news.file_data.file_name }}</td>
                    </tr>
                    <tr>
                        <th></th>
                        <td v-if="news.file_data.mp4 != ''">
                            <video controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="url_protcol+domain+news.file_data.mp4"></video>
                        </td>
                        <td v-if="news.file_data.pdf != ''">
                            <iframe controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="url_protcol+domain+news.file_data.pdf"></iframe>
                        </td>
                    </tr>
                    <tr>
                        <th>メール送信用定型文</th>
                        <td>{{ news.template }}</td>
                    </tr>
                </table>
            </div>
            <div class="sp_confirm_txt">
                <p class="bolder">iPhone 12 表示イメージ</p>
                <p>※スマートフォン端末によって実際の表示は異なります。</p>
            </div>
            <div class="sp_confirm">
                <div class="news_detail_wrap">
                    <h1>{{news.notice_title}}</h1>
                    <p class="delivery_date">{{news.post_date | moment("YYYY/MM/DD HH:mm:ss")}}</p>
                    <div class="news_detail_box">
                        <table width="100%" height="100%">
                            <tr>
                                <th></th>
                                <td>{{ news.notice_text }}</td>
                            </tr>
                            <tr>
                                <th></th>
                                <td v-if="news.file_data.mp4 != ''">
                                    <video controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="url_protcol+domain+news.file_data.mp4"></video>
                                </td>
                                <td v-if="news.file_data.pdf != ''">
                                    <iframe controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="url_protcol+domain+news.file_data.pdf"></iframe>
                                </td>
                            </tr>
                        </table>            
                    </div>
                </div>
            </div>
            <div class="news_edit_btns">
                <router-link :to="{name: 'AdminNewsEdit2'}">戻る</router-link>
                <button class="red_btn" v-on:click="update_notice">登録</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        news: Object
    },
    data () {
        return {
            url_protcol: 'https://',
            domain: '1304kanri.ubiquitous-p.com',
            url_path: '/rest/update_notice/',
            pre_url_path: '/rest/admin_pre_mail/',
            err_catch: false,
            err_mail_catch: false
        }
    },
    methods: {
        update_notice () {
            this.axios
            .post(this.url_protcol + this.domain + this.url_path + this.news.notice_id + '/', {
                'attach_file_mp4': this.news.file_data.mp4,
                'body': this.news.notice_text,
                'title': this.news.notice_title,
                'post_date': this.news.post_date,
                'attach_file_pdf': this.news.file_data.pdf,
                //   'notice_id': this.news.notice_id
                'template': this.news.template
                },{
                    headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
                })
            .then(response => {
            this.$router.push({name: 'AdminNewsList'})
            })
            .catch(error => {
          // エラー処理
            this.err_catch = true
            console.log(error)
            })
        },
        logout() {
        this.$store.commit('reset');
        this.$router.push({name:'aLogin'});
        },
        pre_mail() {
            this.axios
            .post(this.url_protcol + this.domain + this.pre_url_path, {
                "title":this.news.notice_title,
                "body":this.news.notice_text,
                "attach_file_pdf":this.news.file_data.pdf,
                "attach_file_mp4":this.news.file_data.mp4,
                "template":this.news.template
            },{
                headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
            })
            .catch(error => {
                this.err_mail_catch = true
            })
        }
    }
}
</script>

<style scoped>

iframe[src$=".pdf"]{
    width: 100%;
    height: 80vw;
}

.main {
    width: 100vw;
    height: 100vh;
    background-size: cover;
}

.container {
    width: 100vw;
    height: 93vh;
}

h1 {
    margin: 10px 30px;
    word-break: break-all;
}

p.title_txt {
    margin: 10px 30px;
}

.admin_news_confirm_wrap {
    width: 90vw;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    padding: 30px 80px;
}

table {
    width: 100%;
}

th {
    width: 150px;
    padding-right: 30px;
    text-align: right;
    vertical-align: baseline;
    padding-bottom: 30px;
    white-space: nowrap;
}

td {
    padding-bottom: 30px;
    white-space: pre-wrap;
    word-break: break-all;
}

.news_edit_btns {
    display: flex;
    justify-content: space-between;
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

button.red_btn, button.green_btn, .news_edit_btns a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    border: none;
    font-size: inherit;
}

button.red_btn {
    background-color: #F37B6F;
    border: none;
    margin-right: 30px;
}

td video {
    width: 100%;
    height: 420px;
}

.pc_bolder {
    margin: 0 0 10px 10vw;
    font-weight: bolder;
}

.sp_confirm {
    width: 390px;
    height: 844px;
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    border-radius: 10px;
    margin: 0 auto;
    padding: 0 20px;
    overflow: scroll;
}

.sp_confirm_txt {
    margin: 100px 0 30px 10vw;
}

.sp_confirm_txt p {
    margin: 0;
}

.bolder {
    font-weight: bolder;
}

.sp_confirm p.delivery_date {
    margin: 10px 20px;
    font-size: .8em;
    color: #A6A6A6;
}

.sp_confirm h1 {
    font-size: 1.5em;
    padding: 5%;
    margin: 0;
}

.sp_confirm .news_detail_box {
    padding: 50px 5%;
}

.sp_confirm .news_detail_box {
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.6);
}

.sp_confirm th {
    width: 0;
    padding-right: 0;
    text-align: left;
    vertical-align: baseline;
    padding-bottom: 0;
}

.sp_confirm td {
    padding-bottom: 0px;
    white-space: pre-wrap;
    font-size: 12.63px;
}

.err_msg {
    color: #ff6d6d;
    text-align: center;
}


</style>



// WEBPACK FOOTER //
// src/components/AdminNewsConfirm2.vue